import { EntityActions } from '~/apps/shared/actions/consts';
import { PaycodeActions } from '../actions/consts';

type PaycodesUIState = {
  loading: boolean;
  errorMessage: string;
  currentList: [];
  currentPage: number;
}

type PaycodesState = {
  entities: {};
  ui: PaycodesUIState;
}

export function paycodes(
  state = {
    entities: {},
    ui: {
      currentList: [],
      currentPage: 0,
      loading: false,
      errorMessage: '',
    }
  } as PaycodesState, action,
) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.paycodes,
        }
      };
    case PaycodeActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case PaycodeActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case PaycodeActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case PaycodeActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case PaycodeActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
